export default {
    namespaced: true,
    state: {
        projectName: "",
        projectType: ""
    },
    mutations: {
        SET_PROJECT_NAME(state, data) {
            state.projectName = data;
        },
        SET_PROJECT_TYPE(state, data) {
            state.projectType = data;
        }
    }
};
